import { Box, Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import { observer } from "mobx-react";
import { Button, Paper, PaperBorderType } from "@roc/ui";
import { useDocumentStore } from "@roc/feature-documents";
import { PayoffCard } from "./cardComponents/payoffCard";
import { GetApp, MoreVert } from "@material-ui/icons";
import { PayoffProtectiveAdvancesMoreInfoDialog } from "./dialogComponents/payoffProtectiveAdvancesMoreInfoDialog";

const useStyles = makeStyles((theme: Theme) => ({

}));

export const PayoffProtectiveAdvancesCard = observer(({ }) => {
  const classes = useStyles();
  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore },
    },
  } = useDocumentStore();

  return (
    <>
      <Paper titleComponent={
        <Box display="flex" p={2}>
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography variant="h5">
                Unpaid Charges
              </Typography>
            </Grid>
            <Grid item>
              <Grid container justifyContent="flex-end" spacing={1}>
                <Grid item>
                  <Button
                    testId="downloadUnpaidChargesExcel"
                    variant="outlined"
                    size="small"
                    color="primary"
                    onClick={() => payoffCalculatorStore.downloadPayoffExcel('charges')}
                    startIcon={<GetApp />}
                  >
                    Download Excel
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    testId="unpaidChargesMoreInfo"
                    variant="outlined"
                    size="small"
                    color="primary"
                    onClick={() => payoffCalculatorStore.setIsProtectiveAdvancesMoreInfoDialogOpen(true)}
                    startIcon={<MoreVert />}
                  >
                    More Info
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      } borderType={PaperBorderType.SOLID_BORDER}>
        <PayoffCard
          columns={[
            {
              label: 'Name',
              value: 'name',
              width: '30%'
            },
            {
              label: 'Type',
              value: 'type',
              width: '15%'
            },
            {
              label: 'Status',
              value: 'payableStatus',
              width: '15%'
            },
            {
              label: 'Creation Date',
              value: 'createdDate',
              type: 'date',
              width: '20%'
            },
            {
              label: 'Amount',
              value: 'amount',
              type: 'currency',
              width: '20%'
            }
          ]}
          rows={payoffCalculatorStore?.protectiveAdvances}
          total={payoffCalculatorStore?.aggregatedUnpaidCharges}
          compactView={true}
        />
      </Paper>
      <PayoffProtectiveAdvancesMoreInfoDialog />
    </>
  );
});